<template>
  <div :style="{ height, width }" id="EchartsAnimate1" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
          echartsData:{
          }
      }
  },
  mounted(){
          this.loadEchartsAnimate()
  },
  methods:{
      loadEchartsAnimate(){
          var that = this
          var echarts = require('echarts');
          var myCharts = echarts.init(document.getElementById('EchartsAnimate1'));
          var option = {
              color: ["#ffc20e", "#00ae9d"],
               grid: {
                  top: "12%",
                  left: "5%",
                  right: "5%",
                  bottom: "10%",
                  containLabel: true
               },
               tooltip: {
                  trigger: "axis",
                  backgroundColor: "rgba(61, 85, 102, 1)",
                  borderWidth: 1,
                  borderColor: "#9DBAE1", // 边框颜色
                  // 选中线颜色
                  axisPointer: {
                     lineStyle: {
                        color: "#9DBAE1"
                     }
                  },
                  // 字体颜色
                  textStyle: {
                     color: "#fff",
                     fontSize: 26
                  },
                 formatter: function (params) {
                   return params[0].name + '<br/>' +
                     params[0].seriesName + ' : ' + params[0].value + '吨'+ '<br/>' +
                   params[1].seriesName + ' : ' + params[1].value + '吨'
                 }
               },
            legend: {
              show: true,
              top: "0%",
              icon:"circle",
              itemWidth: 30, // 图例标记的图形宽度。
              itemGap: 100, // 图例每项之间的间隔。
              itemHeight: 10, //  图例标记的图形高度。
              textStyle: {
                color: "#fff",
                fontSize: 26,
                padding: [0, 8, 0, 8],
              },
            },
               xAxis: [
                  {
                     type: "category",
                     boundaryGap: false,
                     axisLabel: {
                        interval:0,
                        color: "#fff",
                        fontSize: 26
                     },
                     axisLine: {             
                        lineStyle: {
                           color: "rgba(255,255,255,0.2)"
                        }
                     },
                      splitLine: {
                        show:true,
                        lineStyle: {
                           type: "solid",
                           color: "rgba(255,255,255,.2)",
                           width: 1
                        }
                     },
                     data: ["1月", "2月", "3月", "4月","5月","6月","7月","8月","9月","10月","11月","12月",]
                  }
               ],
               yAxis: [
                  {
                     type: "value",
                    //  name: "吨",
                    // nameTextStyle: {
                    //   color: "#fff",
                    //   fontSize: 30,
                    //   padding: [0,0,10,0]
                    // },
                     axisLabel: {
                        show:true,
                        color: "#fff",
                        fontSize: 26,
                       formatter: function(value) {
                         // 当值为 0 时不显示标签
                         return value === 0 ? '' : value;
                       }
                     },
                     splitLine: {
                        show:true,
                        lineStyle: {
                           type: "solid",
                           color: "rgba(255,255,255,.2)",
                           width: 1
                        }
                     }
                  }
               ],
               series: [
                  {
                     name: "实际灌溉总量",
                     type: "line",
                     smooth: true, // 是否平滑曲线显示
                     symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
                     symbolSize: 0,
                     itemStyle:{
                        normal:{
                           color:'#D7C600',//拐点颜色
                           // borderColor:'#fff',//拐点边框颜色
                           borderWidth:0//拐点边框大小
                        },
                        emphasis: {
                           shadowColor: "rgba(0,0,0, 0.8)", // 阴影颜色
                           shadowBlur: 20 //hover拐点颜色定义
                        }
                     },
                     lineStyle: {
                        normal: {
                           color: "#D7C600", // 线条颜色
                           width:2
                        }
                     },
                     areaStyle: {
                        // 区域填充样式
                        normal: {
                           // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                           color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                              [
                                 {
                                 offset: 0,
                                 color: '#D7C60050'
                                 },
                                 {
                                 offset: 0.3,
                                 color: '#D7C60010'
                                 },
                                 {
                                 offset: 1,
                                 color: '#D7C60000'
                                 }
                              ],
                              false
                           )
                           // shadowColor: "rgba(53,142,215, 0.9)", // 阴影颜色
                           // shadowBlur: 20 // shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                        }
                     },
                     data:[3.2, 3.2, 3.1, 2.6,0,0,0,0,0,0,0,0]
                  },
                 {
                   name: "预计总量",
                   type: "line",
                   smooth: true, // 是否平滑曲线显示
                   symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
                   symbolSize: 0,
                   itemStyle:{
                     normal:{
                       color:'#00D0DC',//拐点颜色
                       // borderColor:'#fff',//拐点边框颜色
                       borderWidth:0//拐点边框大小
                     },
                     emphasis: {
                       shadowColor: "rgba(0,0,0, 0.8)", // 阴影颜色
                       shadowBlur: 20 //hover拐点颜色定义
                     }
                   },
                   lineStyle: {
                     normal: {
                       color: "#00FBE5", // 线条颜色
                       width:2
                     }
                   },
                   areaStyle: {
                     // 区域填充样式
                     normal: {
                       // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                       color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                         [
                           {
                             offset: 0,
                             color: 'rgba(0, 251, 229, .5)'
                           },
                           {
                             offset: 0.3,
                             color: 'rgba(0, 251, 229, 0.2)'
                           },
                           {
                             offset: 1,
                             color: 'rgba(20, 251, 229, 0)'
                           }
                         ],
                         false
                       )
                       // shadowColor: "rgba(53,142,215, 0.9)", // 阴影颜色
                       // shadowBlur: 20 // shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                     }
                   },
                   data:[4.4, 4.2, 4.1, 3.1, 4.7, 2.5, 2.5, 4.1, 3.1, 4.7, 2.5, 2.5]
                 }
               ]
          };

          myCharts.setOption(option);

          // 其他各种图表一个原理
            let index = 0;
            setInterval(function () {
               // 这里的7 为x轴的长度
               if (index >= 7) {
                  index = 0;
               }
               myCharts.dispatchAction({
                  type: "showTip", // 提示框
                  seriesIndex: 0,
                  dataIndex: index // 第 lightIndex 柱子高亮
               });
               index += 1;
            }, 2000);
      }
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
